import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { formatDate } from '@angular/common';
import { Group } from 'src/app/common-class/pages';
import { EncryptionAndDecryption } from 'src/app/COMMON-LOGIC/EncryptionAndDecryption';
import { PreviewData } from 'src/app/common-class/survey';
declare var $: any;

@Component({
  selector: 'app-text-box',
  templateUrl: './text-box.component.html',
  styleUrls: ['./text-box.component.css'],
})
export class TextBoxComponent implements OnInit, OnChanges {
  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isDisplaySubQno: boolean;
  @Input() isMobile: boolean;
  @Input() isMTB: boolean;
  @Input() isGrid: boolean;
  @Input() isOtherControl: boolean;
  @Input() isDemographics: boolean;
  @Input() MonthArray: string[];
  @Input() isNewParticipationButton: boolean;
  @Input() group: Group;
  @Input() isAnySubQMandatory: boolean;

  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  @Output() ChangeLoadingAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  @Output() AnsChangecall: EventEmitter<boolean> = new EventEmitter<boolean>();

  questions: Questions;
  remainingCharacters: number;
  range: boolean;
  selectedYear: any;
  SelectedMonth: any;
  SelectedDate: any;
  setDateText: any;
  ControlDate: any;
  DateFormat: string;
  DateFormatType: any;
  NoOfDays = new Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
  fileToUpload: File = null;
  isrtl: boolean = false;
  ReEnterBlankMessage: string = '';
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  isPreview: boolean;
  isAriaRequired: boolean = false;
  isNewParticipation: boolean;
  surveyFormat: number = 0;
  newParticipationBtnText: string;
  textBoxWidth: string;
  isAnsChange: boolean;
  inValidCount: number = 0;
  inValidRenterCount: number = 0;
  resetPageSub: any;
  CustomAttachmentSizeSurveyID: string;
  strSurveyID: string;
  strCorpNo: string;
  isNegativeCurrencyValue: boolean;
  ReenterTextMulti: string = '';
  resetPage: boolean = false;
  preview: PreviewData;
  date: Date | undefined;
  defaultDate: Date = new Date();
  years: number[] = [];
  months: string[] = [];
  days: number[] = [];

  // Add new properties for PrimeNG datepicker
  dateFormat: string;
  minDate: Date;
  maxDate: Date;
  showIcon: boolean = true;
  showButtonBar: boolean = true;
  showTime: boolean = false;
  showSeconds: boolean = false;
  showMillisecs: boolean = false;
  showOnFocus: boolean = true;
  showOtherMonths: boolean = true;
  selectOtherMonths: boolean = true;
  showWeek: boolean = false;
  disabledDates: Date[] = [];
  disabledDays: number[] = [];
  readonlyInput: boolean = false;
  shortYearCutoff: string = '+10';
  dateInputValue: Date | string = new Date();
  dateInputValue3: Date | string = null;
  dateInputValue4: Date | string = null;
  isDateInvalid: boolean = false;
  isEditPostPop: boolean = false;

  setPreviewData(preview: PreviewData) {
    return (this.preview = preview);
  }
  ngOnChanges(changes: SimpleChanges) {
    let curVal;
    let preVal;
    let change = changes['JsonData'];

    if (change) {
      curVal = JSON.stringify(change.currentValue);
      preVal = JSON.stringify(change.previousValue);
    }

    if (curVal != preVal && preVal != undefined) {
      this.questions = JSON.parse(this.JsonData);
      this.resetPage = false;

      if (
        this.questions.qsubtype == 1 ||
        this.questions.qsubtype == 2 ||
        this.questions.qsubtype == 3 ||
        this.questions.qsubtype == 4
      ) {
        this.setDate();
      }

      if (
        this.questions.qsubtype == 22 &&
        this.questions.AnswerText != null &&
        this.questions.AnswerText != '' &&
        this.questions.AnswerText != undefined &&
        this.questions.isValid
      ) {
        let curValue1 = parseFloat(this.questions.AnswerText);
        if (curValue1 < 0) {
          this.isNegativeCurrencyValue = true;
        }
      }
    }

    if (this.questions) {
      this.setRemainingCharacters();
    }
  }

  constructor(
    public service: ParticipationDataService,
    private changeDetect: ChangeDetectorRef,
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {
    const today = new Date();
    this.maxDate = new Date(today.getFullYear() + 100, today.getMonth(), today.getDate());
    this.minDate = new Date(1753, today.getMonth(), today.getDate());
  }

  ngOnInit() {
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);

      if (this.questions?.qsubtype == 11) {
        this.questions.num_range_1 = '1';
        this.questions.num_range_2 = '5';
      }

      if (this.questions?.qsubtype == 12) {
        this.questions.num_range_1 = '1';
        this.questions.num_range_2 = '9';
      }

      if (this.questions?.qsubtype == 19) {
        this.questions.num_range_2 = '10';
      }
      this.isEditPostPop = this.service.getisEditPostPop();
      this.setRemainingCharacters();

      if (
        this.questions?.qsubtype == 31 &&
        this.questions?.AnswerText == null &&
        this.questions?.PrePopText == null
      ) {
        this.questions.isReEnterEmail = true;
      }

      if (this.questions?.qsubtype == 31 && this.service.getisEditResponse() == true) {
        this.questions.isreenter = 0;
      }

      if (this.service.getRTL()) {
        this.isrtl = true;
      }
      this.CustomAttachmentSizeSurveyID = this.service.CustomAttachmentSizeSurveyID;
      this.strSurveyID = this.service.strSurveyID;
      this.strCorpNo = this.service.strCorpNo;

      //PRT 102718
      if (this.service.getReEnterBlankMessage()) {
        this.ReEnterBlankMessage = this.service.getReEnterBlankMessage();
      }
      this.textBoxWidth = this.getTextBoxWidth();
      if (
        this.questions?.reEnterEmailLabel == undefined ||
        this.questions?.reEnterEmailLabel == null ||
        this.questions?.reEnterEmailLabel == ''
      ) {
        this.ReenterTextMulti = this.service.getSurveyMessages()?.ReenterTextMulti;
      } else {
        this.ReenterTextMulti = this.questions?.reEnterEmailLabel;
      }

      if (
        this.questions?.qsubtype == 22 &&
        this.questions?.AnswerText != null &&
        this.questions?.AnswerText != '' &&
        this.questions?.AnswerText != undefined &&
        this.questions?.isValid
      ) {
        let curValue1 = parseFloat(this.questions.AnswerText);
        if (curValue1 < 0) {
          this.isNegativeCurrencyValue = true;
        }
      }

      // Initialize datepicker settings
      if (
        this.questions?.qsubtype == 1 ||
        this.questions?.qsubtype == 2 ||
        this.questions?.qsubtype == 3 ||
        this.questions?.qsubtype == 4
      ) {
        this.initializeDatePicker();
      }
    }
    this.months = this.MonthArray || [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    // Populate years from 1900 to 2099
    for (let y = 1900; y < 2100; y++) {
      this.years.push(y);
    }

    // Default to 31 days
    this.days = Array.from({ length: 31 }, (_, i) => i + 1);

    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.asObservable().subscribe((data) => {
      this.isFormSubmit = data;
    });

    this.isPreview = this.service.GroupType?.toUpperCase() == 'PREVIEW';
    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;

    this.isAriaRequired =
      (this.questions.mandatory && (this.isMandatoryUpfront || this.questions.isMandatoryStar)) ||
      (this.questions.mandatory && this.isFormSubmit && this.questions.isMandatoryInvalid);
  }

  initializeDatePicker() {
    // Set date format based on qsubtype
    if (this.questions.qsubtype === 2 || this.questions.qsubtype === 4) {
      this.dateFormat = 'dd/mm/yy';
    } else {
      this.dateFormat = 'mm/dd/yy';
    }

    const format = this.dateFormat === 'dd/mm/yy' ? 'dd/mm/yyyy' : 'mm/dd/yyyy';

    // Only set default date if explicitly specified
    if (this.questions.date_default === 'current') {
      this.date = new Date();
      this.dateInputValue = this.formatDate(this.date, format);
    } else if (this.questions.date_default) {
      this.date = this.parseDateFromString(this.questions.date_default, format);
      this.dateInputValue = this.date ? this.formatDate(this.date, format) : '';
    } else {
      // No default date
      this.date = null;
      this.dateInputValue = '';
    }

    // If user has answered a date already
    if (this.questions.AnswerText) {
      const parsed = this.parseDateFromString(this.questions.AnswerText, format);
      if (parsed) {
        this.date = parsed;
        this.dateInputValue = this.formatDate(parsed, format);
      } else {
        this.date = null;
        this.dateInputValue = this.questions.AnswerText;
      }
    }
  }

  parseDateFromString(dateStr: string, format: 'dd/mm/yyyy' | 'mm/dd/yyyy'): Date | null {
    const parts = dateStr.split('/');
    if (parts.length !== 3) return null;

    let day: number, month: number, year: number;

    if (format === 'dd/mm/yyyy') {
      day = +parts[0];
      month = +parts[1] - 1;
      year = +parts[2];
    } else {
      month = +parts[0] - 1;
      day = +parts[1];
      year = +parts[2];
    }

    const date = new Date(year, month, day);
    return isNaN(date.getTime()) ? null : date;
  }

  formatDate(date: Date, format: 'dd/mm/yyyy' | 'mm/dd/yyyy'): string {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();

    return format === 'dd/mm/yyyy' ? `${dd}/${mm}/${yyyy}` : `${mm}/${dd}/${yyyy}`;
  }

  onDateSelect(event: Date) {
    // When a date is selected from the datepicker, it should always be a valid date
    if (event instanceof Date && !isNaN(event.getTime())) {
      // Clear any invalid date flags
      if (this.questions.qsubtype === 3) {
        this.dateInputValue3 = event;
        if ((this.dateInputValue3 as any)?._isInvalidDate) {
          delete (this.dateInputValue3 as any)._isInvalidDate;
        }
      } else if (this.questions.qsubtype === 4) {
        this.dateInputValue4 = event;
        if ((this.dateInputValue4 as any)?._isInvalidDate) {
          delete (this.dateInputValue4 as any)._isInvalidDate;
        }
      } else {
        this.dateInputValue = event;
        if ((this.dateInputValue as any)?._isInvalidDate) {
          delete (this.dateInputValue as any)._isInvalidDate;
        }
      }

      this.questions.AnswerText = this.formatDateString(event, this.DateFormat);
      this.isDateInvalid = false;
      this.questions.isValid = false;

      if (this.questions.qsubtype === 3 || this.questions.qsubtype === 4) {
        const day = event.getDate();
        const month = event.getMonth() + 1;
        const year = event.getFullYear();
        const idPrefix = `Q${this.questions.qno}_${this.questions.UniqueNumber}_T_ID`;
        const daySelect = document.getElementById(idPrefix + '_day') as HTMLSelectElement;
        const monthSelect = document.getElementById(idPrefix + '_month') as HTMLSelectElement;
        const yearSelect = document.getElementById(idPrefix + '_year') as HTMLSelectElement;
        if (daySelect) daySelect.value = day.toString();
        if (monthSelect) monthSelect.value = month.toString();
        if (yearSelect) yearSelect.value = year.toString();
        this.SelectedDate = day;
        this.SelectedMonth = month;
        this.selectedYear = year;
      }

      if (this.questions.Answers?.[0]?.pageto) {
        this.questions.pageto = this.questions.Answers[0].pageto;
      }

      this.UpdateQuestionsDataCommon(this.questions);
    }
  }

  validateDate() {
    this.isDateInvalid = false;
    this.questions.isValid = false;
    // Clear the mandatory invalid flag regardless of validation result
    // This ensures mandatory validation only applies to empty fields
    this.questions.isMandatoryInvalid = false;

    let value: Date | string | null;
    if (this.questions.qsubtype === 3) {
      value = this.dateInputValue3;
    } else if (this.questions.qsubtype === 4) {
      value = this.dateInputValue4;
    } else {
      value = this.dateInputValue;
    }

    // If empty, clear the answer and potentially trigger mandatory validation
    if (!value || value === '') {
      this.isDateInvalid = false;
      this.questions.AnswerText = null;

      // Only set mandatory invalid if the field is truly empty and mandatory
      if (this.questions.mandatory) {
        this.questions.isMandatoryInvalid = true;
      }

      this.UpdateQuestionsDataCommon(this.questions);
      return;
    }

    // For any non-empty value, clear mandatory validation
    this.questions.isMandatoryInvalid = false;

    // Check if the value is a string that represents a date with year < 1753
    if (typeof value === 'string' && !(value as any)?._isInvalidDate) {
      // Try to parse the string as a date
      const datePattern = this.getDatePattern(this.DateFormat);
      if (datePattern.test(value)) {
        const parsedDate = this.parseDateString(value, this.DateFormat);
        if (parsedDate && !isNaN(parsedDate.getTime()) && parsedDate.getFullYear() < 1753) {
          // Valid date but year < 1753
          this.isDateInvalid = true;
          this.questions.isValid = true;

          // Keep the formatted value but mark it as invalid
          this.questions.AnswerText = value;

          if (this.questions.qsubtype === 3) {
            this.dateInputValue3 = value;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue3 as any)._isInvalidDate = true;
          } else if (this.questions.qsubtype === 4) {
            this.dateInputValue4 = value;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue4 as any)._isInvalidDate = true;
          } else {
            this.dateInputValue = value;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue as any)._isInvalidDate = true;
          }

          this.UpdateQuestionsDataCommon(this.questions);
          return;
        }
      }
    }

    // Handle invalid date value that might cause NaN/NaN/NaN
    if (
      typeof value === 'string' &&
      !/^(\d{1,2}[/\-]\d{1,2}[/\-]\d{4}|\d{4}[/\-]\d{1,2}[/\-]\d{1,2})$/.test(value)
    ) {
      this.isDateInvalid = true;
      this.questions.isValid = true;

      // Keep the text but mark it as invalid
      this.questions.AnswerText = value;

      if (this.questions.qsubtype === 3) {
        this.dateInputValue3 = value;
        this.UpdateQuestionsDataCommon(this.questions);
        (this.dateInputValue3 as any)._isInvalidDate = true;
      } else if (this.questions.qsubtype === 4) {
        this.dateInputValue4 = value;
        this.UpdateQuestionsDataCommon(this.questions);
        (this.dateInputValue4 as any)._isInvalidDate = true;
      } else {
        this.dateInputValue = value;
        this.UpdateQuestionsDataCommon(this.questions);
        (this.dateInputValue as any)._isInvalidDate = true;
      }

      this.UpdateQuestionsDataCommon(this.questions);
      return;
    }

    if (value instanceof Date) {
      if (isNaN(value.getTime()) || value.getFullYear() < 1753) {
        this.isDateInvalid = true;
        this.questions.isValid = true;

        // Format the date properly even if it's invalid due to year < 1753
        // This ensures dates like 05/05/1707 display correctly rather than as raw Date objects
        if (!isNaN(value.getTime()) && value.getFullYear() < 1753) {
          // The date is technically valid, just earlier than our business rule allows
          const formattedValue = this.formatDateString(value, this.DateFormat);
          this.questions.AnswerText = formattedValue;

          // Store the formatted value but mark it as invalid
          if (this.questions.qsubtype === 3) {
            this.dateInputValue3 = formattedValue;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue3 as any)._isInvalidDate = true;
          } else if (this.questions.qsubtype === 4) {
            this.dateInputValue4 = formattedValue;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue4 as any)._isInvalidDate = true;
          } else {
            this.dateInputValue = formattedValue;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue as any)._isInvalidDate = true;
          }
        } else {
          // Keep original string representation for truly invalid dates
          const stringValue = value.toString();
          this.questions.AnswerText = stringValue;

          // Mark the date as invalid but preserve the original value
          if (this.questions.qsubtype === 3) {
            this.dateInputValue3 = stringValue;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue3 as any)._isInvalidDate = true;
          } else if (this.questions.qsubtype === 4) {
            this.dateInputValue4 = stringValue;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue4 as any)._isInvalidDate = true;
          } else {
            this.dateInputValue = stringValue;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue as any)._isInvalidDate = true;
          }
        }

        this.UpdateQuestionsDataCommon(this.questions);
        return;
      }
    }

    const datePattern = this.getDatePattern(this.DateFormat);
    if (value != null) {
      if (value instanceof Date) {
        const formatted = this.formatDateString(value, this.DateFormat);
        if (!datePattern.test(formatted)) {
          this.isDateInvalid = true;
          this.questions.isValid = true;
        } else {
          const formattedValue = this.formatDateString(value, this.DateFormat);
          this.questions.AnswerText = formattedValue;
        }
      } else if (typeof value === 'string') {
        if (!datePattern.test(value)) {
          this.isDateInvalid = true;
          this.questions.isValid = true;

          // Keep the original invalid text but mark it as invalid
          this.questions.AnswerText = value;

          // Set a flag to indicate this is an invalid date
          if (this.questions.qsubtype === 3) {
            this.dateInputValue3 = value;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue3 as any)._isInvalidDate = true;
          } else if (this.questions.qsubtype === 4) {
            this.dateInputValue4 = value;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue4 as any)._isInvalidDate = true;
          } else {
            this.dateInputValue = value;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue as any)._isInvalidDate = true;
          }

          this.UpdateQuestionsDataCommon(this.questions);
          return;
        }
        if (!this.isValidDateStrict(value, this.DateFormat)) {
          this.isDateInvalid = true;
          this.questions.isValid = true;
          this.questions.AnswerText = value;
          this.UpdateQuestionsDataCommon(this.questions);
          return;
        }
        const parsedDate = this.parseDateString(value, this.DateFormat);
        if (parsedDate && !isNaN(parsedDate.getTime())) {
          if (parsedDate.getFullYear() < 1753) {
            // Valid date but year < 1753
            this.isDateInvalid = true;
            this.questions.isValid = true;

            // Keep the formatted value but mark it as invalid
            this.questions.AnswerText = value;

            if (this.questions.qsubtype === 3) {
              this.dateInputValue3 = value;
              this.UpdateQuestionsDataCommon(this.questions);
              (this.dateInputValue3 as any)._isInvalidDate = true;
            } else if (this.questions.qsubtype === 4) {
              this.dateInputValue4 = value;
              this.UpdateQuestionsDataCommon(this.questions);
              (this.dateInputValue4 as any)._isInvalidDate = true;
            } else {
              this.dateInputValue = value;
              this.UpdateQuestionsDataCommon(this.questions);
              (this.dateInputValue as any)._isInvalidDate = true;
            }

            this.UpdateQuestionsDataCommon(this.questions);
            return;
          }
          this.date = parsedDate;
          this.isDateInvalid = false;
        } else {
          this.isDateInvalid = true;
          this.questions.isValid = true;

          // Keep the original invalid text but mark it as invalid
          this.questions.AnswerText = value;

          // Set a flag to indicate this is an invalid date
          if (this.questions.qsubtype === 3) {
            this.dateInputValue3 = value;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue3 as any)._isInvalidDate = true;
          } else if (this.questions.qsubtype === 4) {
            this.dateInputValue4 = value;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue4 as any)._isInvalidDate = true;
          } else {
            this.dateInputValue = value;
            this.UpdateQuestionsDataCommon(this.questions);
            (this.dateInputValue as any)._isInvalidDate = true;
          }
        }
      }
    }

    this.UpdateQuestionsDataCommon(this.questions);
  }

  isValidDateStrict(dateStr: string, format: string): boolean {
    let day: number, month: number, year: number;
    const parts = dateStr.split(/[\/\-]/);
    if (parts.length !== 3) return false;

    if (format.toLowerCase() === 'dd/mm/yy') {
      [day, month, year] = parts.map((p) => parseInt(p, 10));
    } else if (format.toLowerCase() === 'mm/dd/yy') {
      [month, day, year] = parts.map((p) => parseInt(p, 10));
    } else {
      return false;
    }

    // JS Date auto-corrects (e.g., 31/04 → 01/05) so we validate strictly
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  }
  formatDateString(date: Date, format: string): string {
    if (!(date instanceof Date) || isNaN(date.getTime())) return '';

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    switch (format) {
      case 'dd/mm/yy':
        return `${day}/${month}/${year}`;
      case 'mm/dd/yy':
        return `${month}/${day}/${year}`;
      case 'yy/mm/dd':
        return `${year}/${month}/${day}`;
      case 'dd-mm-yy':
        return `${day}-${month}-${year}`;
      case 'mm-dd-yy':
        return `${month}-${day}-${year}`;
      case 'yy-mm-dd':
        return `${year}-${month}-${day}`;
      default:
        return `${day}/${month}/${year}`; // Fallback to dd/mm/yy
    }
  }

  getDatePattern(format: string): RegExp {
    switch (format) {
      case 'dd/mm/yy':
        return /^(0[1-9]|[12][0-9]|3[01])[\/](0[1-9]|1[0-2])[\/]\d{4}$/;
      case 'mm/dd/yy':
        return /^(0[1-9]|1[0-2])[\/](0[1-9]|[12][0-9]|3[01])[\/]\d{4}$/;
      case 'yy/mm/dd':
        return /^\d{4}[\/](0[1-9]|1[0-2])[\/](0[1-9]|[12][0-9]|3[01])$/;
      default:
        return /^(0[1-9]|[12][0-9]|3[01])[\/](0[1-9]|1[0-2])[\/]\d{4}$/;
    }
  }

  parseDateString(dateString: string, format: string): Date | null {
    const parts = dateString.split(/[/\-]/);

    if (parts.length !== 3) return null;

    let day, month, year;

    switch (format) {
      case 'dd/mm/yy':
        [day, month, year] = parts.map(Number);
        break;
      case 'mm/dd/yy':
        [month, day, year] = parts.map(Number);
        break;
      case 'yy/mm/dd':
        [year, month, day] = parts.map(Number);
        break;
      default:
        return null;
    }

    const date = new Date(year, month - 1, day);
    return isNaN(date.getTime()) ? null : date;
  }

  onDateInput(event: any) {
    const inputValue = event?.target?.value || '';

    // Clear mandatory validation flag regardless of validation result

    // Clear validation flags when input is empty
    if (inputValue === '') {
      this.isDateInvalid = false;
      this.questions.isValid = false;
      this.questions.AnswerText = null;
      this.questions.isMandatoryInvalid = false;

      // Only set mandatory invalid if the field is truly empty and mandatory
      if (this.questions.mandatory && inputValue !== '') {
        this.questions.isMandatoryInvalid = true;
      }

      // Update the model
      if (this.questions.qsubtype === 3) {
        this.dateInputValue3 = null;
      } else if (this.questions.qsubtype === 4) {
        this.dateInputValue4 = null;
      } else {
        this.dateInputValue = null;
      }

      this.UpdateQuestionsDataCommon(this.questions);
      return;
    }

    // Any non-empty value means it's not a mandatory validation issue
    this.questions.isMandatoryInvalid = false;

    // Check for obviously invalid dates first with a basic regex pattern
    if (!/^(\d{1,2}[\/\-]\d{1,2}[\/\-]\d{4}|\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2})$/.test(inputValue)) {
      this.isDateInvalid = true;
      this.questions.isValid = true;
      this.questions.error_msg = 'Please enter a valid date';

      // Keep the original invalid text for display
      this.questions.AnswerText = inputValue;

      // Keep the value in the model but mark it as invalid to prevent NaN/NaN/NaN
      if (this.questions.qsubtype === 3) {
        this.dateInputValue3 = inputValue;
        (this.dateInputValue3 as any)._isInvalidDate = true;
      } else if (this.questions.qsubtype === 4) {
        this.dateInputValue4 = inputValue;
        (this.dateInputValue4 as any)._isInvalidDate = true;
      } else {
        this.dateInputValue = inputValue;
        (this.dateInputValue as any)._isInvalidDate = true;
      }

      this.UpdateQuestionsDataCommon(this.questions);
      return;
    }

    // Parse the input value based on the date format
    const parsedDate = this.parseDateFromString(
      inputValue,
      this.dateFormat === 'dd/mm/yy' ? 'dd/mm/yyyy' : 'mm/dd/yyyy',
    );

    if (parsedDate && !isNaN(parsedDate.getTime())) {
      // Date is technically valid, check for business rule (year < 1753)
      if (parsedDate.getFullYear() < 1753) {
        this.isDateInvalid = true;
        this.questions.isValid = true;
        this.questions.error_msg = 'Please enter a valid date';

        // Format the date correctly even though it's invalid by business rules
        this.questions.AnswerText = inputValue;

        if (this.questions.qsubtype === 3) {
          this.dateInputValue3 = inputValue;
          (this.dateInputValue3 as any)._isInvalidDate = true;
        } else if (this.questions.qsubtype === 4) {
          this.dateInputValue4 = inputValue;
          (this.dateInputValue4 as any)._isInvalidDate = true;
        } else {
          this.dateInputValue = inputValue;
          (this.dateInputValue as any)._isInvalidDate = true;
        }

        this.UpdateQuestionsDataCommon(this.questions);
        return;
      }

      // Valid date entered
      if (this.questions.qsubtype === 3) {
        this.dateInputValue3 = parsedDate;
      } else if (this.questions.qsubtype === 4) {
        this.dateInputValue4 = parsedDate;
      } else {
        this.dateInputValue = parsedDate;
      }

      this.questions.AnswerText = this.formatDateString(parsedDate, this.DateFormat);
      this.isDateInvalid = false;
      this.questions.isValid = false;

      // Update pageto if needed
      if (this.questions.Answers?.[0]?.pageto) {
        this.questions.pageto = this.questions.Answers[0].pageto;
      }

      this.UpdateQuestionsDataCommon(this.questions);
    } else {
      // Invalid date
      this.isDateInvalid = true;
      this.questions.isValid = true;
      this.questions.error_msg = 'Please enter a valid date';

      // Keep the original invalid text
      this.questions.AnswerText = inputValue;

      // Keep the value in the model but mark it as invalid to prevent NaN/NaN/NaN
      if (this.questions.qsubtype === 3) {
        this.dateInputValue3 = inputValue;
        (this.dateInputValue3 as any)._isInvalidDate = true;
      } else if (this.questions.qsubtype === 4) {
        this.dateInputValue4 = inputValue;
        (this.dateInputValue4 as any)._isInvalidDate = true;
      } else {
        this.dateInputValue = inputValue;
        (this.dateInputValue as any)._isInvalidDate = true;
      }

      this.UpdateQuestionsDataCommon(this.questions);
    }
  }

  ngAfterViewInit() {
    document.querySelectorAll('.dtpContainer').forEach(function (el) {
      (el as HTMLElement).style.display = 'none';
    });

    if (
      this.questions.qsubtype == 1 ||
      this.questions.qsubtype == 2 ||
      this.questions.qsubtype == 3 ||
      this.questions.qsubtype == 4
    ) {
      if (
        this.questions.qsubtype == 1 ||
        this.questions.qsubtype == 2 ||
        this.questions.qsubtype == 3 ||
        this.questions.qsubtype == 4
      ) {
        this.setDate();
      } else if (this.questions.qsubtype === 71) {
        window.addEventListener('click', () => {
          const validatorMessages = document.querySelectorAll(
            '.attachment-cont .validator_message',
          );
          validatorMessages.forEach((el) => {
            (el as HTMLElement).style.display = 'none';
          });
        });
      }
    }
    // 508 aria-label
    const monthElem = document.querySelector('.ui-datepicker-month');
    if (monthElem) {
      monthElem.setAttribute('aria-label', 'Month');
    }

    const yearElem = document.querySelector('.ui-datepicker-year');
    if (yearElem) {
      yearElem.setAttribute('aria-label', 'Year');
    }

    if (this.questions.qsubtype === 71 && this.questions.AnswerText != null) {
      const btnBrowse = document.getElementById(
        'btnBrowse_' + this.questions.UniqueNumber,
      ) as HTMLButtonElement;
      const fileInput = document.getElementById(
        'File_' + this.questions.qno + '_' + this.questions.UniqueNumber,
      ) as HTMLInputElement;
      const lnkRemove = document.getElementById('lnkRemove_' + this.questions.UniqueNumber);

      if (btnBrowse) btnBrowse.disabled = true;
      if (fileInput) fileInput.disabled = true;
      if (lnkRemove) {
        lnkRemove.style.display = 'block';
        lnkRemove.style.visibility = 'visible';

        const attachTb = lnkRemove.closest('.attach-tb');
        if (attachTb) attachTb.classList.add('delete-on');
      }

      if (this.questions.AnswerText !== '') {
        const desktopIcon = btnBrowse?.closest('.desktopfile-icon');
        if (desktopIcon) desktopIcon.classList.add('disabled');
      }
    }

    this.isAriaRequired =
      (this.questions.mandatory && (this.isMandatoryUpfront || this.questions.isMandatoryStar)) ||
      (this.questions.mandatory && this.isFormSubmit && this.questions.isMandatoryInvalid);
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        this.isAnsChange = false;
        this.resetPage = true;
        this.clearAnswerOnPageReset();
      }
    });
    this.changeDetect.detectChanges();
  }
  // Helper method to find closest element with a class (similar to jQuery's closest)
  private findClosestByClass(element: HTMLElement, className: string): HTMLElement | null {
    let current = element;
    while (current) {
      if (current.classList && current.classList.contains(className)) {
        return current;
      }
      current = current.parentElement;
    }
    return null;
  }

  ngOnDestroy() {
    this.isFormSubmitSub.unsubscribe();
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  setURLPrePopText(strPreText: string): string {
    if (strPreText == null || strPreText == undefined) {
      return null;
    }

    let arrWebsiteURL = strPreText.split('.');

    if (
      (arrWebsiteURL.length >= 3 && arrWebsiteURL[0].toLowerCase() == 'www') ||
      strPreText.indexOf('http') == 0
    ) {
      if (strPreText.split(' ').length == 1) {
        if (strPreText.indexOf('http') == 0) {
          return "<a href='" + strPreText + "'  target=_blank>" + strPreText + '</a>';
        } else {
          return "<a href='http://" + strPreText + "'  target=_blank>" + strPreText + '</a>';
        }
      } else {
        if (strPreText.indexOf('http') == 0) {
          return (
            "<a href='" +
            strPreText.substr(0, strPreText.split(' ')[0].length) +
            "'  target=_blank>" +
            strPreText.substr(0, strPreText.split(' ')[0].length) +
            '</a>' +
            '<span>' +
            strPreText.substr(strPreText.split(' ')[0].length, strPreText.length) +
            '</span>'
          );
        } else {
          return (
            "<a href='http://" +
            strPreText.substr(0, strPreText.split(' ')[0].length) +
            "'  target=_blank>" +
            strPreText.substr(0, strPreText.split(' ')[0].length) +
            '</a>' +
            '<span>' +
            strPreText.substr(strPreText.split(' ')[0].length, strPreText.length) +
            '</span>'
          );
        }
      }
    } else if (strPreText.indexOf('http') >= 0 || strPreText.indexOf('www') >= 0) {
      if (strPreText.indexOf('http') >= 0) {
        if (
          strPreText.substr(strPreText.split('http')[0].length, strPreText.length).split(' ')
            .length == 1
        ) {
          return (
            '<span>' +
            strPreText.substr(0, strPreText.split('http')[0].length) +
            '</span>' +
            "<a href='" +
            strPreText.substr(strPreText.split('http')[0].length, strPreText.length) +
            "'  target=_blank>" +
            strPreText.substr(strPreText.split('http')[0].length, strPreText.length) +
            '</a>'
          );
        } else {
          return (
            '<span>' +
            strPreText.substr(0, strPreText.split('http')[0].length) +
            '</span>' +
            "<a href='" +
            strPreText.substr(strPreText.split('http')[0].length, strPreText.length).split(' ')[0] +
            "'  target=_blank>" +
            strPreText.substr(strPreText.split('http')[0].length, strPreText.length).split(' ')[0] +
            '</a>' +
            '<span>' +
            strPreText.substr(
              strPreText.split('http')[0].length +
                strPreText
                  .substr(strPreText.split('http')[0].length, strPreText.length)
                  .split(' ')[0].length,
              strPreText.length,
            ) +
            '</span>'
          );
        }
      } else {
        if (
          strPreText.substr(strPreText.split('www')[0].length, strPreText.length).split(' ')
            .length == 1
        ) {
          return (
            '<span>' +
            strPreText.substr(0, strPreText.split('www')[0].length) +
            '</span>' +
            "<a href='http://" +
            strPreText.substr(strPreText.split('www')[0].length, strPreText.length) +
            "'  target=_blank>" +
            strPreText.substr(strPreText.split('www')[0].length, strPreText.length) +
            '</a>'
          );
        } else {
          return (
            '<span>' +
            strPreText.substr(0, strPreText.split('www')[0].length) +
            '</span>' +
            "<a href='http://" +
            strPreText.substr(strPreText.split('www')[0].length, strPreText.length).split(' ')[0] +
            "'  target=_blank>" +
            strPreText.substr(strPreText.split('www')[0].length, strPreText.length).split(' ')[0] +
            '</a>' +
            '<span>' +
            strPreText.substr(
              strPreText.split('www')[0].length +
                strPreText
                  .substr(strPreText.split('www')[0].length, strPreText.length)
                  .split(' ')[0].length,
              strPreText.length,
            ) +
            '</span>'
          );
        }
      }
    }

    return null;
  }

  //Set date according to date formate
  setDate() {
    let currentDate;
    if (this.questions.qsubtype == 2 || this.questions.qsubtype == 4) {
      this.DateFormat = 'dd/mm/yy';
      this.DateFormatType = 2;
      currentDate = formatDate(new Date(), 'dd/MM/yyyy', 'en');
    } else {
      this.DateFormat = 'mm/dd/yy';
      this.DateFormatType = 1;
      currentDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    }
    this.DateFormat = this.DateFormat == '' ? 'mm/dd/yyyy' : this.DateFormat;

    if (
      (this.questions.AnswerText != '' &&
        this.questions.AnswerText != null &&
        this.questions.date_default != 'current') ||
      (this.ControlDate != null && this.questions.date_default != 'current') ||
      (this.questions.AnswerText != '' &&
        this.questions.AnswerText != null &&
        this.questions.AnswerText != 'current')
    ) {
      this.ControlDate = this.questions.AnswerText;
    } else if (this.questions.date_default != null) {
      if (this.questions.date_default == 'current') {
        this.ControlDate = currentDate;
      } else {
        this.ControlDate = this.questions.date_default;
      }
    }

    if (this.ControlDate != null) {
      const dt = this.ControlDate.split('/');

      // Check for valid date parts
      if (dt.length !== 3 || dt.some((part) => !part || isNaN(parseInt(part)))) {
        // Invalid date format, don't populate the datepicker model
        this.questions.AnswerText = this.ControlDate;
        return;
      }

      let mon, day, yr;
      if (this.DateFormatType == 1) {
        mon = dt[0];
        day = dt[1];
        yr = dt[2];
      } else if (
        this.DateFormatType == 2 &&
        this.questions.date_default != null &&
        this.questions.date_default != 'current' &&
        this.questions.AnswerText == this.questions.date_default &&
        dt[0] != ''
      ) {
        mon = dt[0];
        day = dt[1];
        yr = dt[2];
        this.ControlDate = day + '/' + mon + '/' + yr;
      } else {
        day = dt[0];
        mon = dt[1];
        yr = dt[2];
      }

      // Parse as integers and validate
      const parsedDay = parseInt(day);
      const parsedMonth = parseInt(mon);
      const parsedYear = parseInt(yr);

      // Basic date validation
      if (
        isNaN(parsedDay) ||
        isNaN(parsedMonth) ||
        isNaN(parsedYear) ||
        parsedDay < 1 ||
        parsedDay > 31 ||
        parsedMonth < 1 ||
        parsedMonth > 12 ||
        parsedYear < 1753
      ) {
        // Invalid date, don't populate the datepicker model
        this.questions.AnswerText = this.ControlDate;
        return;
      }

      this.selectedYear = yr;
      this.SelectedDate = parsedDay;
      this.SelectedMonth = parsedMonth;
      this.setDateText = this.ControlDate;

      // Create date object and validate it's not invalid (e.g., Feb 30)
      const dateObj = new Date(parsedYear, parsedMonth - 1, parsedDay);
      if (
        isNaN(dateObj.getTime()) ||
        dateObj.getDate() !== parsedDay ||
        dateObj.getMonth() !== parsedMonth - 1 ||
        dateObj.getFullYear() !== parsedYear
      ) {
        // Invalid date, don't populate the datepicker model
        this.questions.AnswerText = this.ControlDate;
        return;
      }

      // Set valid date in model
      if (this.questions.qsubtype === 3) {
        this.dateInputValue3 = dateObj;
        this.dateInputValue = dateObj;
      } else if (this.questions.qsubtype === 4) {
        this.dateInputValue4 = dateObj;
        this.dateInputValue = dateObj;
      } else {
        this.dateInputValue = dateObj;
      }
    }

    this.questions.AnswerText = this.ControlDate;

    if (this.questions.AnswerText == '') {
      this.questions.AnswerText = null;
    } else {
      this.questions.pageto = this.questions.Answers?.[0].pageto;
    }

    if (
      this.questions.population_type == 3 &&
      (this.questions.PrePopText == '' || this.questions.PrePopText == null)
    ) {
      this.questions.PrePopText = this.ControlDate;
    }

    if (this.questions.AnswerText != null) this.ChangeLoadingAnswersData.emit(this.questions);

    this.changeDetect.detectChanges();
  }

  SelectedValue(answer: { target: HTMLSelectElement; selectdId?: number }) {
    if (answer.target.value === '0') {
      this.questions.isOtherAnswer = false;
      this.questions.selectAnsValue = 0;
      this.questions.AnswerID = 0;
      this.questions.AnswerText = '';
      this.questions.pageto = null;
    } else {
      for (let i = 0; i < this.questions.Answers.length; i++) {
        if (answer.target.value === this.questions.Answers[i].value_id.toString()) {
          if (answer.selectdId !== undefined) {
            answer.selectdId = 1;
          }
          this.questions.Answers[i].selectdId = 1;
          this.questions.AnswerID = this.questions.Answers[i].ms_id;
          this.questions.selectAnsValue = this.questions.Answers[i].value_id;
          this.questions.AnswerText = this.questions.Answers[i].value_text;
          this.questions.pageto = this.questions.Answers[i].pageto;
          this.questions.otherAnswer = null;

          if (this.questions.isSoftRequired) {
            this.questions.isSoftRequiredHandle = true;
          }
          if (this.questions.Answers[i].isOther) {
            this.questions.isOtherAnswer = true;
          } else {
            this.questions.isOtherAnswer = false;
          }
        } else {
          this.questions.Answers[i].ControlAns = null;
          this.questions.Answers[i].selectdId = 0;
        }
      }
    }
    this.UpdateQuestionsDataCommon(this.questions);
  }

  onBlurMethod() {
    if (this.questions.AnswerText != null && this.questions.AnswerText.replace(/\s/g, '') == '') {
      this.questions.AnswerText = null;
    }
    if (this.questions.AnswerText != null && this.questions.AnswerText != '') {
      this.questions.pageto = this.questions.Answers[0].pageto;
    } else {
      this.questions.pageto = 0;
    }
    this.UpdateQuestionsDataCommon(this.questions);
  }

  //Show Remaining Characters out of Character Limit
  keytab_remainingChar(event: any, curVal: string) {
    this.isAnsChange = true;
    this.AnsChangecall.emit(this.isAnsChange);
    if (this.questions.Showcharlimit) {
      this.remainingCharacters = this.questions.characterLimit - curVal.length;
    }
  }

  SetControlValue(value: any, self) {
    self.questions.AnswerText = value;
    self.questions.isValid = false;
    self.questions.pageto = this.questions.Answers[0].pageto;
    this.UpdateQuestionsDataCommon(this.questions);
  }

  ValidationForSubQuestionType(event: any, curVal: any) {
    // Clear mandatory invalid flag by default - only empty fields can be mandatory invalid
    this.questions.isMandatoryInvalid = false;

    if (curVal == '') {
      this.questions.isValid = false;
      this.questions.AnswerText = null;
      this.inValidCount = 0;

      // Only set mandatory invalid if the field is truly empty and mandatory
      if (this.questions.mandatory) {
        this.questions.isMandatoryInvalid = true;
      }

      if (this.questions.qsubtype == 31) {
        this.questions.isReEnterEmailValid = false;
        this.questions.isReEnterEmail = true;
        this.questions.otherAnswer = null;
        this.inValidRenterCount = 0;
      }
      this.UpdateQuestionsDataCommon(this.questions);
      return;
    }

    // Any non-empty value means it's not a mandatory validation issue, even if invalid
    this.questions.isMandatoryInvalid = false;

    if (
      this.questions.qsubtype == 22 ||
      this.questions.qsubtype == 41 ||
      this.questions.qsubtype == 21
    ) {
      if (curVal.indexOf(' ') == -1) {
        this.NumberValidation(event, curVal);
      } else {
        this.questions.isValid = true;
        return;
      }
    } else if (this.questions.qsubtype == 11) {
      this.PostalCodeValidation(curVal);
    } else if (this.questions.qsubtype == 61 || this.questions.qsubtype == 62) {
      this.PhoneValidation(curVal);
    } else if (this.questions.qsubtype == 51) {
      this.SSNValidation(curVal);
    } else if (this.questions.qsubtype == 12) {
      this.PostalCodePlusFourValidation(curVal);
    } else if (this.questions.qsubtype == 10) {
      this.CustomValidation(curVal);
    } else if (this.questions.qsubtype == 31) {
      this.EmailValidation(curVal);
    } else if (
      this.questions.qsubtype == 1 ||
      this.questions.qsubtype == 2 ||
      this.questions.qsubtype == 3 ||
      this.questions.qsubtype == 4
    ) {
      this.ValidateDate(event, curVal);
      this.DatePickerValidation(event, curVal);
    } else if (this.questions.qsubtype == 63 || this.questions.qsubtype == 64) {
      this.ValidateNumPhone(curVal);
    }
    this.questions.pageto = this.questions.Answers[0].pageto;

    if (this.questions.isValid && this.inValidCount == 0) {
      let control = document.getElementById(
        'Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID',
      );
      this.inValidCount++;
      setTimeout(function () {
        control.focus();
      }, 0);
    }
    this.UpdateQuestionsDataCommon(this.questions);
  }

  PostalCodePlusFourValidation(curVal: any) {
    if (
      curVal != '' &&
      (isNaN(curVal) || (curVal.length != 5 && curVal.length < 9) || curVal.length > 9)
    ) {
      this.range = true;
      this.questions.isValid = true;
      return;
    } else {
      this.questions.isValid = false;
    }
  }

  EmailValidation(curVal: string) {
    const regexp = new RegExp(/^([a-zA-Z0-9_\.\'\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z])+$/);
    let isValid = regexp.test(curVal);
    if (isValid) {
      this.range = false;
      this.questions.isReEnterEmail = false;
      this.questions.isValid = false;

      if (this.questions.isreenter == 1) {
        let control = document.getElementById(
          'Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID_ReEnter',
        );
        setTimeout(function () {
          control.focus();
        }, 0);
      }
    } else {
      this.range = true;
      this.questions.isReEnterEmail = true;
      this.questions.isValid = true;

      this.questions.otherAnswer = null;
      this.questions.isReEnterEmailValid = false;
    }
    this.service.setQuestionChange(this.questions);
  }
  //Compare Email & Re-enter email
  CompareReEnterEmail(event: any, curVal: string) {
    if (curVal == this.questions.AnswerText || curVal == this.questions.PrePopText) {
      this.questions.isReEnterEmailValid = false;
      this.questions.isValid = false;
    } else {
      if (this.questions.AnswerText == null) {
        this.questions.isValid = false;
        this.questions.AnswerText = null;

        if (this.questions.qsubtype == 31) {
          this.questions.isReEnterEmailValid = false;
          this.questions.isReEnterEmail = true;
          this.questions.otherAnswer = null;
        }
      } else {
        this.questions.isReEnterEmailValid = true;
        this.questions.isValid = true;
        this.questions.pageto = this.questions.Answers[0].pageto;

        if (this.inValidRenterCount == 0) {
          let control = document.getElementById(
            'Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID_ReEnter',
          );
          this.inValidRenterCount++;
          setTimeout(function () {
            control.focus();
          }, 0);
        }
      }
      this.service.setQuestionChange(this.questions);
    }
    this.UpdateQuestionsDataCommon(this.questions);
  }

  PostalCodeValidation(curVal: any) {
    this.range = false;

    if ((curVal != '' && isNaN(curVal)) || curVal.length < 5 || curVal.length > 5) {
      this.range = true;
      this.questions.isValid = true;
      return;
    } else {
      this.questions.isValid = false;
    }
  }

  NumberValidation(event: any, curVal: any) {
    this.range = false;
    this.isNegativeCurrencyValue = false;
    let curValue1 = parseFloat(curVal);
    let min1 = parseFloat(this.questions.num_range_1);
    let max1 = parseFloat(this.questions.num_range_2);

    if (curVal != '') {
      if (isNaN(curVal) || curValue1 < min1 || curValue1 > max1) {
        this.range = true;
        this.questions.isValid = true;
        return;
      } else if (this.questions.qsubtype == 22 && curValue1 < 0) {
        this.questions.isValid = true;
        this.isNegativeCurrencyValue = true;
        return;
      } else {
        this.questions.isValid = false;

        if (this.questions.AllowOnlyInteger) {
          if (Number.isInteger(curValue1) && curVal.indexOf('.') < 0) {
            this.questions.isValid = false;
          } else {
            this.questions.isValid = true;
          }
        }
      }
    } else {
      this.questions.isValid = true;
    }
  }

  PhoneValidation(objTextBox: any) {
    let phone = objTextBox;

    if (phone == '') {
      return true;
    }

    let matchArr1 = phone.match(/^(\d{10})$/);
    let matchArr2 = phone.match(/^(\d{3})-?\d{3}-?\d{4}$/);
    let matchArr3 = phone.match(/^(\d{3})-?\d{7}$/);
    let matchArr4 = phone.match(/^\(\d{3}\)\s\d{3}-\d{4}$/);

    if (matchArr1 != null || matchArr2 != null || matchArr3 != null || matchArr4 != null) {
      if (matchArr4 == null) {
        phone = phone.replace(/-/g, '');
        phone =
          '(' + phone.substring(0, 3) + ') ' + phone.substring(3, 6) + '-' + phone.substring(6, 10);
      }
      this.questions.AnswerText = phone;
      this.questions.isValid = false;
      return true;
    } else {
      this.range = true;
      this.questions.isValid = true;
      return false;
    }
  }
  // Validate phone number format
  ValidateNumPhone(objTextBox: string) {
    const phone = objTextBox;

    if (phone === '') {
      this.questions.isValid = false;
      return;
    }

    // Get telformat attribute - we'll need to use the DOM to find the element
    // since we can't directly access the attribute from the string parameter
    const id = 'Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID';
    const inputElement = document.getElementById(id);
    const phoneFormat = inputElement ? inputElement.getAttribute('telformat') : null;

    let matchArr1, matchArr2, matchArr3, matchArr4;
    matchArr1 = phone.match(/^(\d{13})$/);
    matchArr2 = phone.match(/^\d{3}\s\d{3}\s\d{3}-\d{4}$/);
    matchArr3 = phone.match(/^\d{3}-?\d{10}$/);
    matchArr4 = phone.match(/^\d{3}-\d{3}-\d{3}-\d{4}$/);

    if (matchArr1 != null || matchArr2 != null || matchArr3 != null || matchArr4 != null) {
      if (matchArr4 == null) {
        let formattedPhone = phone.replace(/-/g, '');
        if (phoneFormat === 'domestic') {
          formattedPhone =
            '(' +
            formattedPhone.substring(0, 3) +
            ') ' +
            formattedPhone.substring(3, 6) +
            '-' +
            formattedPhone.substring(6, 10);
        } else {
          formattedPhone =
            '' +
            formattedPhone.substring(0, 3) +
            '-' +
            formattedPhone.substring(3, 6) +
            '-' +
            formattedPhone.substring(6, 9) +
            '-' +
            formattedPhone.substring(9, 13);
        }
        this.questions.AnswerText = formattedPhone;
      }
      this.questions.isValid = false;
    } else {
      this.range = true;
      this.questions.isValid = true;
    }
  }

  SSNValidation(curVal: any) {
    let matchArr1 = curVal.match(/^(\d{9})$/);
    let matchArr2 = curVal.match(/^(\d{3})-?\d{2}-?\d{4}$/);

    if (matchArr1 != null || matchArr2 != null) {
      this.questions.isValid = false;
    } else {
      this.range = true;
      this.questions.isValid = true;
      return;
    }
  }

  CustomValidation(curVal: string) {
    this.VCF(
      curVal,
      this.questions.error_msg,
      this.questions.custom_format,
      this.questions.custom_format,
    );
  }

  VCF(Tboxvalue, strErrMsg, custom_format, row) {
    if (Tboxvalue.length > 0 && Tboxvalue.length == row.length) {
      for (let i = 0; i < row.length; i++) {
        var TB = Tboxvalue.toString().charAt(i);
        var characters = TB.match(/^[a-zA-Z]*$/);
        var numbers = TB.match(/^[0-9]*$/);
        var RowIndex = row.toString().charAt(i);
        if ((characters == null && RowIndex == '@') || (numbers == null && RowIndex == '#')) {
          var isValid = true;
          break;
        } else if (
          (characters != null && RowIndex == '@') ||
          (numbers != null && RowIndex == '#')
        ) {
        } else if (TB == RowIndex) {
        } else {
          var isValid = true;
          break;
        }
      }
    } else if (Tboxvalue.length == custom_format.length) {
      for (let i = 0; i < custom_format.length; i++) {
        var TB = Tboxvalue.toString().charAt(i);
        var characters = TB.match(/^[a-zA-Z]*$/);
        var numbers = TB.match(/^[0-9]*$/);
        var RowIndex = custom_format.toString().charAt(i);
        if ((characters == null && RowIndex == '@') || (numbers == null && RowIndex == '#')) {
          var isValid = true;
          break;
        } else if (
          (characters != null && RowIndex == '@') ||
          (numbers != null && RowIndex == '#')
        ) {
        } else if (TB == RowIndex) {
        } else {
          var isValid = true;
          break;
        }
      }
    } else {
      var isValid = true;
    }

    if (isValid) {
      this.range = true;
      this.questions.isValid = true;
      return false;
    } else if (Tboxvalue.length != 0) {
      let Custom = this.CustomForm(custom_format, Tboxvalue);
      this.questions.isValid = false;
      return Custom;
    }
  }

  CustomForm(custom_format, Tboxvalue) {
    for (let k = 0; k < custom_format.length; k++) {
      var CustomFormatIndex = custom_format.toString().charAt(k);
      if (
        Tboxvalue.length != custom_format.length &&
        CustomFormatIndex.match(/^[a-zA-Z]*$/) == null &&
        CustomFormatIndex.match(/^[0-9]*$/) == null
      ) {
        if (CustomFormatIndex != '@' && CustomFormatIndex != '#') {
          var abc = CustomFormatIndex;
          var strLeft = Tboxvalue.substring(0, k);
          var strRight = Tboxvalue.substring(k + 1, custom_format.length);
          var str = strLeft + abc + strRight;
          Tboxvalue = str;
        }
      }
    }
    return Tboxvalue;
  }

  // date picker validation

  DatePickerValidation(event: any, curVal: any) {
    if (curVal != '' && this.questions.isValid != true) {
      if (isNaN(curVal)) {
        this.questions.isValid = false;
        this.questions.AnswerText = curVal;
        return;
      } else {
        this.questions.isValid = false;
      }
    } else {
      this.questions.isValid = true;
    }
  }
  separator: string;
  posDate: any;
  posMonth: any;
  posYear: any;
  lenYear: any;
  setDateVariables(intDateFormatType) {
    switch (intDateFormatType) {
      case 1:
        this.separator = '/';
        this.posDate = 1;
        this.posMonth = 0;
        this.posYear = 2;
        this.lenYear = 4;
        break;
      case 2:
        this.separator = '/';
        this.posDate = 0;
        this.posMonth = 1;
        this.posYear = 2;
        this.lenYear = 4;
        break;
    }
  }

  isLeapYear(year) {
    return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0 ? true : false;
  }

  ValidateDate(event: any, curVal: any) {
    let strDate = curVal;

    this.setDateVariables(this.DateFormatType);

    let arrDate = strDate.split(this.separator);

    if (arrDate.length != 3) {
      this.questions.isValid = true;
      return;
    }
    if (
      arrDate[0] == '' ||
      arrDate[1] == '' ||
      arrDate[2] == '' ||
      arrDate[this.posMonth].length > 2 ||
      arrDate[this.posDate].length > 2 ||
      arrDate[this.posYear].length != this.lenYear ||
      arrDate[this.posYear] < 1753
    ) {
      this.questions.isValid = true;
      return;
    }

    if (arrDate[0].length < 2 || arrDate[1].length < 2) {
      this.questions.isValid = true;
      return;
    }

    for (let i = 0; i < arrDate.length; i++) {
      let strTemp = arrDate[i];

      for (let j = 0; j < strTemp.length; j++) {
        if (strTemp.substring(j, j + 1) == ' ' || isNaN(strTemp.substring(j, j + 1))) {
          this.questions.isValid = true;
          return;
        }
      }
    }

    if (arrDate[this.posMonth] > 12 || arrDate[this.posMonth] < 1) {
      this.questions.isValid = true;
      return;
    }

    if (arrDate[this.posMonth] != 2) {
      if (
        arrDate[this.posDate] > this.NoOfDays[arrDate[this.posMonth] - 1] ||
        arrDate[this.posDate] < 1
      ) {
        this.questions.isValid = true;
        return;
      }
    } else {
      if (this.isLeapYear(arrDate[this.posYear])) {
        if (arrDate[this.posDate] > 29 || arrDate[this.posDate] < 1) {
          this.questions.isValid = true;
          return;
        }
      } else {
        if (arrDate[this.posDate] > 28 || arrDate[this.posDate] < 1) {
          this.questions.isValid = true;
          return;
        }
      }
    }
    this.questions.isValid = false;
  }

  keyup() {
    this.isAnsChange = true;
    this.AnsChangecall.emit(this.isAnsChange);
    this.questions.isValid = false;
  }

  ReEnter_keyup() {
    this.questions.isValid = false;
    this.questions.isReEnterEmailValid = false;

    if (this.questions.otherAnswer == '') {
      this.questions.otherAnswer = null;
    }
  }

  // Fill dropdown date
  pupulate(selectItem: string) {
    //PRT 9381
    const id = 'Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID';
    const daySelect = document.getElementById(id + '_day') as HTMLSelectElement;
    const monthSelect = document.getElementById(id + '_month') as HTMLSelectElement;
    const yearSelect = document.getElementById(id + '_year') as HTMLSelectElement;

    if (!daySelect || !monthSelect || !yearSelect) return false;

    const selectElement = document.getElementById(id + selectItem) as HTMLSelectElement;
    const selectIndex = selectElement ? selectElement.selectedIndex : -1;

    // Calculate days in month using the selected year and month
    const selectedYear = parseInt(yearSelect.options[yearSelect.selectedIndex].text);
    const selectedMonth = parseInt(monthSelect.options[monthSelect.selectedIndex].value);

    const timeA = new Date(selectedYear, selectedMonth, 1);
    const timeDifference = timeA.getTime() - 86400000;
    const timeB = new Date(timeDifference);
    const daysInMonth = timeB.getDate();

    const selectedDay = daySelect.selectedIndex;

    // if (daySelect.options.length === daysInMonth) {
    //   return false;
    // }

    // Remove all existing day options
    while (daySelect.options.length > 0) {
      daySelect.options[0] = null;
    }

    // Add new day options
    for (let i = 0; i < daysInMonth; i++) {
      const j = i + 1;
      const option = new Option(j.toString(), j.toString());
      daySelect.options[i] = option;
    }

    // Set selected day
    if (daysInMonth > selectedDay) {
      daySelect.options[selectedDay].selected = true;
    } else {
      daySelect.options[daysInMonth - 1].selected = true;

      // If there's a select element with id 'select' + daySelect.id, update its text
      const selectDayElement = document.getElementById('select' + daySelect.id);
      if (selectDayElement) {
        selectDayElement.textContent = daysInMonth.toString();
      }
    }

    // Update date text and answer text
    if (this.questions.qsubtype === 4) {
      this.setDateText = daySelect.value + '/' + monthSelect.value + '/' + yearSelect.value;
    } else {
      this.setDateText = monthSelect.value + '/' + daySelect.value + '/' + yearSelect.value;
    }

    const day = Number(daySelect.value);
    const month = Number(monthSelect.value);
    const year = Number(yearSelect.value);

    if (day && month && year) {
      const newDate = new Date(year, month - 1, day);
      if (!isNaN(newDate.getTime())) {
        if (this.questions.qsubtype === 3) {
          this.dateInputValue3 = newDate;
        } else if (this.questions.qsubtype === 4) {
          this.dateInputValue4 = newDate;
        } else {
          this.dateInputValue = newDate;
        }
        if (this.questions.qsubtype === 4) {
          this.setDateText = `${day}/${month}/${year}`;
        } else {
          this.setDateText = `${month}/${day}/${year}`;
        }
        this.questions.AnswerText = this.setDateText;
      }
    }

    this.questions.AnswerText = this.setDateText;
    this.questions.pageto = this.questions.Answers[0].pageto;
    this.UpdateQuestionsDataCommon(this.questions);
  }

  isUserExtInvalid: boolean = false;
  handleFileInput(files: FileList, event: Event) {
    const target = event.target as HTMLElement;
    const loaderElement = document.getElementById('loader_' + this.questions.UniqueNumber);
    if (loaderElement) {
      this.renderer.setStyle(loaderElement, 'display', '');
    }

    this.fileToUpload = files[0];
    const surveykey = this.service.getSurveykey();
    const recno = this.service.getRecNO();
    const GroupType = this.service.getGroupType();
    let strStatus = '';

    if (GroupType.toUpperCase() == 'PREVIEW') {
      strStatus = '&status=preview';
    }

    const url =
      'PostAttachedFile?k=' + surveykey + '&recNo=' + recno + '&qid=' + this.questions.UniqueNumber;
    let strMessage = '';
    const formData: FormData = new FormData();
    formData.append('uploadedFiles', this.fileToUpload, this.fileToUpload.name);
    const fileSize = this.fileToUpload.size / 1024 / 1024;

    if (fileSize > 10 && this.CustomAttachmentSizeSurveyID.indexOf(this.strSurveyID) > -1) {
      this.questions.error_msg = 'The file to upload cannot exceed 10 MB.';
      this.questions.isValid = true;

      if (target instanceof HTMLInputElement) {
        target.value = '';
      }

      if (loaderElement) {
        this.renderer.setStyle(loaderElement, 'display', 'none');
      }

      // Show the validation message
      const validatorMessage = this.findClosestByClass(target, 'attachment-cont')?.querySelector(
        '.validator_message',
      );
      if (validatorMessage) {
        this.renderer.setStyle(validatorMessage, 'display', 'block');
      }
    } else if (fileSize > 5 && this.CustomAttachmentSizeSurveyID.indexOf(this.strSurveyID) == -1) {
      this.questions.error_msg = 'The file to upload cannot exceed 5 MB.';
      this.questions.isValid = true;

      if (target instanceof HTMLInputElement) {
        target.value = '';
      }

      if (loaderElement) {
        this.renderer.setStyle(loaderElement, 'display', 'none');
      }

      // Show the validation message
      const validatorMessage = this.findClosestByClass(target, 'attachment-cont')?.querySelector(
        '.validator_message',
      );
      if (validatorMessage) {
        this.renderer.setStyle(validatorMessage, 'display', 'block');
      }
    } else if (this.validateExtension(this.fileToUpload.name)) {
      this.service.postAttachedFile(url, formData).subscribe(
        async (data) => {
          const arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', await data);
          const parsedData = JSON.parse(arrData);
          strMessage = parsedData.Message;
          if (strMessage.toUpperCase() == 'SUCCESS' && parsedData.FileName != '') {
            this.questions.AnswerText = parsedData.FileName;
            this.questions.pageto = this.questions.Answers[0].pageto;
            this.UpdateQuestionsDataCommon(this.questions);

            const btnBrowse = document.getElementById('btnBrowse_' + this.questions.UniqueNumber);
            const fileInput = document.getElementById(
              'File_' + this.questions.qno + '_' + this.questions.UniqueNumber,
            );
            const lnkRemove = document.getElementById('lnkRemove_' + this.questions.UniqueNumber);

            if (btnBrowse) {
              this.renderer.setProperty(btnBrowse, 'disabled', true);
            }

            if (fileInput) {
              this.renderer.setProperty(fileInput, 'disabled', true);
            }
            if (loaderElement) {
              this.renderer.setStyle(loaderElement, 'display', 'none');
            }
            if (lnkRemove) {
              this.renderer.setStyle(lnkRemove, 'display', 'block');
              this.renderer.setStyle(lnkRemove, 'visibility', 'visible');

              const attachTb = this.findClosestByClass(lnkRemove, 'attach-tb');
              if (attachTb) {
                this.renderer.addClass(attachTb, 'delete-on');
              }
            }

            const desktopFileIcon = btnBrowse
              ? this.findClosestByClass(btnBrowse, 'desktopfile-icon')
              : null;
            if (desktopFileIcon) {
              this.renderer.addClass(desktopFileIcon, 'disabled');
            }

            this.questions.isValid = false;
          } else {
            this.questions.error_msg = strMessage;
            this.questions.isValid = true;

            if (target instanceof HTMLInputElement) {
              target.value = '';
            }

            if (loaderElement) {
              this.renderer.setStyle(loaderElement, 'display', 'none');
            }

            const validatorMessage = this.findClosestByClass(
              target,
              'attachment-cont',
            )?.querySelector('.validator_message');
            if (validatorMessage) {
              this.renderer.setStyle(validatorMessage, 'display', 'block');
            }
          }
        },
        (error) => {
          console.log(error);
        },
      );
    } else {
      if (this.isUserExtInvalid) {
        const dot = '.';
        const comma = ',';
        const custom_format =
          this.questions.custom_format
            .replace(new RegExp(dot.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), "'.")
            .replace(new RegExp(comma.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), "',") + "'";
        if (!this.questions.error_msg) {
          this.questions.error_msg = `This file extension is not allowed. Allowed file extension(s) are ${custom_format}. Please select a file with allowed extensions and try again.`;
        } else {
          this.questions.error_msg = this.questions.error_msg.replace('<<ext>>', custom_format);
        }
      } else {
        this.questions.error_msg =
          'This file type is not supported. Please review your entered file type and try again.';
      }
      this.questions.isValid = true;
      if (target instanceof HTMLInputElement) {
        target.value = '';
      }

      if (loaderElement) {
        this.renderer.setStyle(loaderElement, 'display', 'none');
      }

      const validatorMessage = this.findClosestByClass(target, 'attachment-cont')?.querySelector(
        '.validator_message',
      );
      if (validatorMessage) {
        this.renderer.setStyle(validatorMessage, 'display', 'block');
      }
    }
  }

  deleteFile() {
    if (confirm('Are you sure you want to remove the file?')) {
      this.questions.AnswerText = null;
      this.questions.pageto = null;
      this.UpdateQuestionsDataCommon(this.questions);

      // Enable browse button
      const btnBrowse = document.getElementById('btnBrowse_' + this.questions.UniqueNumber);
      if (btnBrowse) {
        this.renderer.setProperty(btnBrowse, 'disabled', false);
      }

      // Reset file input
      const fileInput = document.getElementById(
        'File_' + this.questions.qno + '_' + this.questions.UniqueNumber,
      ) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
        this.renderer.setProperty(fileInput, 'disabled', false);
      }

      // Hide remove link
      const lnkRemove = document.getElementById('lnkRemove_' + this.questions.UniqueNumber);
      if (lnkRemove) {
        this.renderer.setStyle(lnkRemove, 'display', 'none');
        this.renderer.setStyle(lnkRemove, 'visibility', 'hidden');

        // Remove class from parent
        const attachTb = this.findClosestByClass(lnkRemove, 'attach-tb');
        if (attachTb) {
          this.renderer.removeClass(attachTb, 'delete-on');
        }
      }

      // Remove disabled class from desktop file icon
      if (btnBrowse) {
        const desktopFileIcon = this.findClosestByClass(btnBrowse, 'desktopfile-icon');
        if (desktopFileIcon) {
          this.renderer.removeClass(desktopFileIcon, 'disabled');
        }
      }
    }
  }

  validateExtension(FileName: string) {
    let ext: string;
    let customFormats: any = [];
    let arrFileName = FileName.split('.');
    if (arrFileName.length > 0) {
      ext = arrFileName[arrFileName.length - 1];
    }
    var ExtensionArray = [
      'ZIP',
      'EXE',
      'RAR',
      'MSI',
      'ADE',
      'ADP',
      'APK',
      'BAT',
      'CHM',
      'CMD',
      'COM',
      'CPL',
      'DLL',
      'DMG',
      'EXE',
      'HTA',
      'INS',
      'ISP',
      'JAR',
      'JS',
      'JSE',
      'LIB',
      'LNK',
      'MDE',
      'MSC',
      'MSI',
      'MSP',
      'MST',
      'NSH',
      'PIF',
      'SCR',
      'SCT',
      'SHB',
      'SYS',
      'VB',
      'VBE',
      'VBS',
      'VXD',
      'WSC',
      'WSF',
      'WSH',
      'CAB',
    ];

    if (this.questions.custom_format != '') {
      customFormats = this.questions.custom_format.split(',').map((format) => {
        let extenstionToken = format.split('.');
        return extenstionToken[extenstionToken.length - 1].toUpperCase();
      });
    }

    // Validate System Allowed Extensions
    if (ExtensionArray.indexOf(ext.toUpperCase()) > -1) {
      return false;
    }
    // User Allowed Extensions if Any
    else if (
      customFormats &&
      customFormats.length > 0 &&
      customFormats.indexOf(ext.toUpperCase()) == -1
    ) {
      this.isUserExtInvalid = true;
      return false;
    }
    return true;
  }

  getTextClass() {
    switch (this.questions.qsubtype) {
      case 11:
      case 12:
        return 'zipcode';
      case 21:
        return 'number';
      case 22:
        return 'currency';
      case 51:
        return 'ssn';
      case 31:
        return 'email';
      case 41:
        return 'percentage';
      case 61:
        return 'phone';
      default:
        return '';
    }
  }

  getCurrencyMessage() {
    return this.service.getCurrencyNegativeMessage();
  }

  clickEvent(event: any) {
    event.preventDefault();
    event.stopPropagation();
  }

  setRemainingCharacters() {
    if (this.questions?.Showcharlimit) {
      this.remainingCharacters = this.questions.characterLimit;

      if (this.questions?.AnswerText != null) {
        this.remainingCharacters = this.questions.characterLimit - this.questions.AnswerText.length;
      }
    }
  }

  uploadFile(event: KeyboardEvent) {
    if (event.keyCode == 13) {
      const fileInput = document.getElementById(
        `File_${this.questions.qno}_${this.questions.UniqueNumber}`,
      ) as HTMLElement;
      if (fileInput) {
        fileInput.click();
      }
    }
  }

  uploadFileclick() {
    const fileInput = document.getElementById(
      `File_${this.questions.qno}_${this.questions.UniqueNumber}`,
    ) as HTMLElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  keyDown(event: KeyboardEvent) {
    const qsubtypes = [21, 22, 51, 41, 61, 11, 12];

    if (qsubtypes.includes(this.questions.qsubtype)) {
      const keyCode = event.which || event.keyCode;
      const isLetterKey = keyCode >= 65 && keyCode <= 90;
      const isControlKey = event.ctrlKey || event.metaKey;

      // Allow Ctrl+A, Ctrl+C and Ctrl+V
      if (isControlKey && (keyCode === 65 || keyCode === 67 || keyCode === 86)) {
        return true;
      }

      // Block letter keys for specific qsubtypes
      if (isLetterKey) {
        event.preventDefault();
        return false;
      }
    }

    this.isAnsChange = true;
    this.AnsChangecall.emit(this.isAnsChange);
    this.UpdateQuestionsData(this.questions);
  }

  UpdateQuestionsData(question: Questions) {
    this.questions = question;
    this.UpdateQuestionsDataCommon(question);
  }

  UpdateQuestionsDataCommon(question: Questions) {
    if (question.AnswerText != null) {
      this.isAnsChange = true;
      this.AnsChangecall.emit(this.isAnsChange);
    }
    this.ChangeAnswersData.emit(question);
  }

  gotoNextQuestion(question: Questions, event: HTMLElement) {
    if (
      !question.isValid &&
      !(question.isreenter == 1 && question.otherAnswer == null && question.AnswerText != null)
    ) {
      if (question.isMatrixQuestion) {
        // Get scroll target element
        const bodyScrollElement = document.getElementById('bodyScroll');
        if (!bodyScrollElement) return;

        const checkIfPreview = this.service.preview && this.service.preview.viewport;

        // Find next inactive question
        const activeQues = this.findClosestByClass(event, 'active-ques');
        let nextbtnLength = 0;
        let nextInactiveElement = null;

        if (activeQues) {
          // Get all next siblings that are inactive-ques with question-data
          const nextInactiveElements = this.getNextSiblingsByClass(activeQues, 'inactive-ques');
          const nextQuestionsElements = nextInactiveElements.filter((elem) => {
            return elem.querySelector('.question-data') !== null;
          });

          nextbtnLength = nextQuestionsElements.length;
          nextInactiveElement = nextQuestionsElements.length > 0 ? nextQuestionsElements[0] : null;
        }

        // Matrix element positions
        let matrixElem = this.findClosestByClass(
          event,
          `matrix-mobile-subQ_${this.group.Matrix_id}`,
        );
        let matrixNextElements = matrixElem
          ? this.getNextSiblingsByClass(matrixElem, `matrix-mobile-subQ_${this.group.Matrix_id}`)
          : [];

        // Filter to only get elements with question-data
        matrixNextElements = matrixNextElements.filter((elem) => {
          return elem.querySelector('.question-data') !== null;
        });

        // Also find matrix-mobile-subQ-cont elements
        const matrixContElem = this.findClosestByClass(event, 'matrix-mobile-subQ-cont');
        let matrixNextContElements = matrixContElem
          ? this.getNextSiblingsByClass(matrixContElem, 'matrix-mobile-subQ-cont')
          : [];

        // Check if we need to scroll to the next matrix element
        let targetScrollElement = bodyScrollElement;
        let scrollPosition = 0;

        if (matrixNextElements.length > 0 && matrixNextElements[0].getBoundingClientRect()) {
          // Calculate scroll position for matrix next element
          const elemTop = matrixNextElements[0].getBoundingClientRect().top;

          if (checkIfPreview && checkIfPreview !== '') {
            if (this.service.preview.viewport === 'web') {
              const toolbarHeight = document.querySelector('.toolbar')?.clientHeight || 0;
              scrollPosition =
                elemTop -
                bodyScrollElement.getBoundingClientRect().top +
                bodyScrollElement.scrollTop -
                toolbarHeight;
            } else {
              targetScrollElement = document.querySelector('.app-participation') as HTMLElement;
              if (targetScrollElement) {
                scrollPosition =
                  elemTop -
                  targetScrollElement.getBoundingClientRect().top +
                  targetScrollElement.scrollTop;
              }
            }
          } else {
            scrollPosition =
              elemTop - bodyScrollElement.getBoundingClientRect().top + bodyScrollElement.scrollTop;
          }

          // Perform smooth scroll animation
          this.smoothScrollTo(targetScrollElement, scrollPosition - window.innerHeight / 3, 400);
        } else if (
          matrixNextContElements.length > 0 &&
          matrixNextContElements[0].getBoundingClientRect()
        ) {
          // Calculate scroll position for matrix next container element
          const elemTop = matrixNextContElements[0].getBoundingClientRect().top;

          if (checkIfPreview && checkIfPreview !== '') {
            if (this.service.preview.viewport === 'web') {
              const toolbarHeight = document.querySelector('.toolbar')?.clientHeight || 0;
              scrollPosition =
                elemTop -
                bodyScrollElement.getBoundingClientRect().top +
                bodyScrollElement.scrollTop -
                toolbarHeight;
            } else {
              targetScrollElement = document.querySelector('.app-participation') as HTMLElement;
              if (targetScrollElement) {
                scrollPosition =
                  elemTop -
                  targetScrollElement.getBoundingClientRect().top +
                  targetScrollElement.scrollTop;
              }
            }
          } else {
            scrollPosition =
              elemTop - bodyScrollElement.getBoundingClientRect().top + bodyScrollElement.scrollTop;
          }

          // Perform smooth scroll animation
          this.smoothScrollTo(targetScrollElement, scrollPosition - window.innerHeight / 3, 400);
        } else if (nextInactiveElement && nextInactiveElement.getBoundingClientRect()) {
          // Calculate scroll position for next inactive question element
          const elemTop = nextInactiveElement.getBoundingClientRect().top;

          if (checkIfPreview && checkIfPreview !== '') {
            if (this.service.preview.viewport === 'web') {
              const toolbarHeight = document.querySelector('.toolbar')?.clientHeight || 0;
              scrollPosition =
                elemTop -
                bodyScrollElement.getBoundingClientRect().top +
                bodyScrollElement.scrollTop -
                toolbarHeight;
            } else {
              targetScrollElement = document.querySelector('.app-participation') as HTMLElement;
              if (targetScrollElement) {
                scrollPosition =
                  elemTop -
                  targetScrollElement.getBoundingClientRect().top +
                  targetScrollElement.scrollTop;
              }
            }
          } else {
            scrollPosition =
              elemTop - bodyScrollElement.getBoundingClientRect().top + bodyScrollElement.scrollTop;
          }

          // Perform smooth scroll animation
          this.smoothScrollTo(targetScrollElement, scrollPosition - window.innerHeight / 3, 400);
        } else {
          // If there are no next questions, scroll to the footer
          if (checkIfPreview && checkIfPreview !== '') {
            if (this.service.preview.viewport === 'web') {
              targetScrollElement = document.getElementById('bodyScroll');
            } else {
              targetScrollElement = document.querySelector('.app-participation') as HTMLElement;
            }
          }

          const footerElement = document.querySelector('.tblPageFooter');
          if (footerElement && targetScrollElement) {
            const scrollVal =
              footerElement.getBoundingClientRect().top + targetScrollElement.scrollTop;
            this.smoothScrollTo(targetScrollElement, scrollVal, 400);
          }
        }
      } else {
        this.service.gotoNextQuestion(question, event);
      }
    }
  }

  // Helper method for smooth scrolling
  private smoothScrollTo(element: HTMLElement, to: number, duration: number) {
    if (!element) return;

    const start = element.scrollTop;
    const change = to - start;
    const increment = 20;
    let currentTime = 0;

    const animateScroll = () => {
      currentTime += increment;
      const val = this.easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };

    animateScroll();
  }

  // Easing function for smooth scrolling
  private easeInOutQuad(t: number, b: number, c: number, d: number): number {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }

  // Helper method to get next siblings with a specific class
  private getNextSiblingsByClass(element: HTMLElement, className: string): HTMLElement[] {
    const siblings: HTMLElement[] = [];
    let nextSibling = element.nextElementSibling as HTMLElement;

    while (nextSibling) {
      if (nextSibling.classList && nextSibling.classList.contains(className)) {
        siblings.push(nextSibling);
      }
      nextSibling = nextSibling.nextElementSibling as HTMLElement;
    }

    return siblings;
  }

  getTextBoxWidth() {
    let width = this.questions?.twidth;
    if (!this.isMobile) {
      if (this.questions?.qsubtype == 61 || this.questions?.qsubtype == 51) {
        width = 40;
      } else if (
        this.questions?.qsubtype == 22 ||
        this.questions?.qsubtype == 11 ||
        this.questions?.qsubtype == 12
      ) {
        width = 30;
      } else if (this.questions?.qsubtype == 41) {
        width = 20;
      }
    }
    return width + '%';
  }

  gotoNextQuestionKeyboard(question: Questions, event: KeyboardEvent) {
    event.preventDefault();
    // Cast the event target to HTMLElement for the gotoNextQuestion method
    this.gotoNextQuestion(question, event.target as HTMLElement);
  }

  clearAnswerOnPageReset() {
    // Clear date-related values for date question types (qsubtype 1, 2, 3, 4)
    if (
      this.questions?.qsubtype == 1 ||
      this.questions?.qsubtype == 2 ||
      this.questions?.qsubtype == 3 ||
      this.questions?.qsubtype == 4
    ) {
      // Clear date input values
      this.dateInputValue = null;
      this.dateInputValue3 = null;
      this.dateInputValue4 = null;
      this.date = null;
      this.ControlDate = null;
      this.setDateText = null;

      // Clear dropdown selections
      this.selectedYear = null;
      this.SelectedMonth = null;
      this.SelectedDate = null;

      // Clear date validation flags
      this.isDateInvalid = false;

      // Reset dropdown elements if they exist
      const idPrefix = `Q${this.questions.qno}_${this.questions.UniqueNumber}_T_ID`;
      const daySelect = document.getElementById(idPrefix + '_day') as HTMLSelectElement;
      const monthSelect = document.getElementById(idPrefix + '_month') as HTMLSelectElement;
      const yearSelect = document.getElementById(idPrefix + '_year') as HTMLSelectElement;

      if (daySelect) daySelect.selectedIndex = 0;
      if (monthSelect) monthSelect.selectedIndex = 0;
      if (yearSelect) yearSelect.selectedIndex = 0;
    }

    // Clear attachment-related values for file upload question type (qsubtype 71)
    if (this.questions?.qsubtype == 71) {
      // Clear file upload
      this.fileToUpload = null;

      // Reset file input
      const fileInput = document.getElementById(
        'File_' + this.questions.qno + '_' + this.questions.UniqueNumber,
      ) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
        this.renderer.setProperty(fileInput, 'disabled', false);
      }

      // Enable browse button
      const btnBrowse = document.getElementById('btnBrowse_' + this.questions.UniqueNumber);
      if (btnBrowse) {
        this.renderer.setProperty(btnBrowse, 'disabled', false);
      }

      // Hide remove link
      const lnkRemove = document.getElementById('lnkRemove_' + this.questions.UniqueNumber);
      if (lnkRemove) {
        this.renderer.setStyle(lnkRemove, 'display', 'none');
        this.renderer.setStyle(lnkRemove, 'visibility', 'hidden');

        // Remove class from parent
        const attachTb = this.findClosestByClass(lnkRemove, 'attach-tb');
        if (attachTb) {
          this.renderer.removeClass(attachTb, 'delete-on');
        }
      }

      // Remove disabled class from desktop file icon
      if (btnBrowse) {
        const desktopFileIcon = this.findClosestByClass(btnBrowse, 'desktopfile-icon');
        if (desktopFileIcon) {
          this.renderer.removeClass(desktopFileIcon, 'disabled');
        }
      }
    }

    // Clear the answer text and validation flags for all question types
    this.questions.AnswerText = null;
    this.questions.isValid = false;
    this.questions.isMandatoryInvalid = false;
    this.questions.pageto = null;

    // Clear other answer for email re-enter validation
    if (this.questions?.qsubtype == 31) {
      this.questions.otherAnswer = null;
      this.questions.isReEnterEmail = true;
      this.questions.isReEnterEmailValid = false;
    }

    // Reset validation counters
    this.inValidCount = 0;
    this.inValidRenterCount = 0;

    // Clear currency validation flag
    this.isNegativeCurrencyValue = false;

    // Update the questions data
    this.UpdateQuestionsDataCommon(this.questions);
  }

  getRemainingChar(): string {
    return this.service.getSurveyMessages().RemainingChr;
  }

  // get isDateInvalid(): boolean {
  //   // Show error only if input is not empty and not a valid date
  //   if (!this.dateInputValue) return false;
  //   const parts = this.dateInputValue.split('/');
  //   if (parts.length !== 3) return true;
  //   const d = new Date(Number(parts[2]), Number(parts[0]) - 1, Number(parts[1]));
  //   return isNaN(d.getTime());
  // }

  onDateBlur() {
    // Do not clear input, just validate
    this.onDateInput(this.dateInputValue);
  }

  // Add this new method to handle datepicker close event
  onDatePickerClose() {
    // When the datepicker closes, validate the current date value
    let value: Date | string | null;

    if (this.questions.qsubtype === 3) {
      value = this.dateInputValue3;
    } else if (this.questions.qsubtype === 4) {
      value = this.dateInputValue4;
    } else {
      value = this.dateInputValue;
    }

    // Skip if the value is empty or already marked as invalid
    if (!value || (value as any)?._isInvalidDate) {
      return;
    }

    // Check if it's a valid date with year < 1753
    if (value instanceof Date && !isNaN(value.getTime()) && value.getFullYear() < 1753) {
      this.isDateInvalid = true;
      this.questions.isValid = true;
      this.questions.error_msg = 'Please enter a valid date';

      // Format the date properly
      const formattedValue = this.formatDateString(value, this.DateFormat);
      this.questions.AnswerText = formattedValue;

      // Store the formatted value but mark it as invalid
      if (this.questions.qsubtype === 3) {
        this.dateInputValue3 = formattedValue;
        (this.dateInputValue3 as any)._isInvalidDate = true;
      } else if (this.questions.qsubtype === 4) {
        this.dateInputValue4 = formattedValue;
        (this.dateInputValue4 as any)._isInvalidDate = true;
      } else {
        this.dateInputValue = formattedValue;
        (this.dateInputValue as any)._isInvalidDate = true;
      }

      this.UpdateQuestionsDataCommon(this.questions);
    }
  }

  // Add this new method for datepicker click outside event
  onDateInputValidation(event: any) {
    // Get current value in the date input
    let value: Date | string | null;

    if (this.questions.qsubtype === 3) {
      value = this.dateInputValue3;
    } else if (this.questions.qsubtype === 4) {
      value = this.dateInputValue4;
    } else {
      value = this.dateInputValue;
    }

    // If empty, nothing to do
    if (!value) return;

    // If it's already marked as invalid, nothing to do
    if ((value as any)?._isInvalidDate) return;

    // For string inputs, check if it contains text but isn't a valid date
    if (typeof value === 'string' && value.trim() !== '') {
      const datePattern = this.getDatePattern(this.DateFormat);

      // If it doesn't match date pattern or can't be parsed, clear it instead of showing error
      if (!datePattern.test(value)) {
        // Clear the input instead of showing validation error
        this.questions.AnswerText = null;

        if (this.questions.qsubtype === 3) {
          this.dateInputValue3 = null;
        } else if (this.questions.qsubtype === 4) {
          this.dateInputValue4 = null;
        } else {
          this.dateInputValue = null;
        }

        this.isDateInvalid = false;
        this.questions.isValid = false;
        this.UpdateQuestionsDataCommon(this.questions);
      } else {
        // Input matches date pattern, check if it's a valid date
        const parsedDate = this.parseDateString(value, this.DateFormat);
        if (!parsedDate || isNaN(parsedDate.getTime())) {
          // Clear the input instead of showing validation error
          this.questions.AnswerText = null;

          if (this.questions.qsubtype === 3) {
            this.dateInputValue3 = null;
          } else if (this.questions.qsubtype === 4) {
            this.dateInputValue4 = null;
          } else {
            this.dateInputValue = null;
          }

          this.isDateInvalid = false;
          this.questions.isValid = false;
          this.UpdateQuestionsDataCommon(this.questions);
        }
      }
    }
  }
}
